import { useContext, useCallback } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

const useLabel = () => {
  const { api, userID } = useContext(GlobalContext);

  const pushItemBarcode = useCallback( async (requests = []) => {
     if (!api) {
        toast.error("API configuration not found");
        return null;
      }

      if (!userID) {
        toast.error("User ID not found");
        return null;
      }

      if (!Array.isArray(requests) || requests.length === 0) {
        toast.error("Please select at least one item");
        return null;
      }

    try {
      const payload = {
        fk_userid: userID,
        requests,
      };

      const response = await api.post("/Admin/pushItemBarcode",
        payload,
      );

      if (response.data?.responseCode === "00") {
        toast.success(
          response.data?.responseMessage || "Barcode pushed successfully"
        );
        return response.data;
      }

      toast.error(response.data?.responseMessage || "Failed to push barcode");
      return response.data;
    } catch (error) {
      console.error("Push barcode API error:", error);
      toast.error("Error pushing barcode");
      return null;
    }
  },
  [api, userID],
);

  return {
    pushItemBarcode,
  };
};

export default useLabel;
